module.exports = __webpack_public_path__ + "static/media/dropDown.6c96fb01.svg";